import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  // OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef, Renderer2, HostListener
} from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import {
  AssessmentActions,
  ViewActions,
  AssessmentService
} from '../../logics';

import {
  Utils,
} from '../../services';

import { helpers } from '../../helpers';
import { INTERACTIVE_LABEL } from "../../constants";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
  selector: 'cs-page-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div 
      class="cs-page-content"
      [ngClass]="{
        'has-text': inputs.currentUnderstandingText,
        'video-max': videoMaximized,
        'audio-extended': (hasAudioContent && audioContentStyle === 'extended')
      }"
      #container>
        <div 
          (click)="closeScrollAlert()"
          class="scroll-alert-area"
          *ngIf="isMobile && !scrollAlertClosed">
          <img src="assets/img/press-and-drag.png">
          <a class="cs-btn cs-btn-light">
            <span class="ion-close"></span>
          </a>
        </div>
        <div class="cs-page-content__contenuto-audio-wrapper"
             *ngIf="hasContenutoAudio() && audioContentStyle === 'standard'"
             [ngStyle]="{
                   'margin-left': audioMarginLeft + 'px', 
                   'margin-top': (audioMarginTop) + 'px'
                   }"
          >
          <cs-player
            [inputs]="{
                  currentId: inputs.currentPlayerId,
                  src: contenutoAudioSrc
                }"
            (play)="audioClick(true, $event)"
            (stop)="audioClick(false)">
          </cs-player>
          <div class="cs-page-content__contenuto-audio-wrapper__title">{{audioContentTitle}}</div>
        </div>
        <div class="cs-page-content__contenuto-video-wrapper"
             *ngIf="hasVideoContent === 1"
             [ngStyle]="{
                   'margin-left': videoMarginLeft + 'px', 
                   'margin-top': (videoMarginTop) + 'px'
                   }"
             #videoComponentWrapper
          >
          <div class="cs-page-content__contenuto-video-wrapper__title">{{videoContentTitle}}</div>
          <div class="cs-page-content__contenuto-video-component"
               (mouseenter)="mouseEnterInVideoWrapper($event)"
               (mouseleave)="mouseLeaveInVideoWrapper($event)"
               [ngClass]="{
                   'video-small': !videoMaximized,
                   'video-max': videoMaximized
                 }"
               [ngStyle]="{
                   'width': videoCurrentWidth,
                   'height': videoCurrentHeight
                   }"
               #videoComponent
          >

            <iframe frameborder="0"
                    width="100%"
                    height="100%"
                    [src]="safeVideoSrc"
            >
            </iframe>
            <div class="contenuto-video__action-wrapper"
                 [ngClass]="{
                   'is-over': mouseInVideoWrapper
                 }"
            >
              <a (click)="toggleMaximizedVideo($event)" *ngIf="!videoMaximized">
                <span class="ion-android-expand"></span>
              </a>
              <a (click)="toggleMaximizedVideo($event)" *ngIf="videoMaximized">
                <span class="ion-android-contract"></span>
              </a>
            </div>
          </div>
        </div>
        <div class="cs-page-content__inner">
          <div
            class="cs-page-content__top-text"
            *ngIf="inputs.currentUnderstandingText && inputs.currentUnderstandingText.items && inputs.currentUnderstandingText.items.length > 0">
            <ng-container *ngFor="let item of inputs.currentUnderstandingText.items">
              <span *ngIf="item.type == 'html'" [innerHTML]="item.content"></span>
              <span class="answer" *ngIf="item.type == 'placeholder'" [innerHTML]="item.content" [ngStyle]="getUnderstandingTextAnswerStyle(item)"></span>
              <select *ngIf="item.type == 'select'" (change)="onSelectChangeAnswer($event, item.questionId)">
                <ng-container *ngFor="let opt of item.options">
                  <option [value]="opt.id" [innerText]="opt.letter + opt.text" selected="selected" *ngIf="opt.visible && opt.selected"></option>
                  <option [value]="opt.id" [innerText]="opt.letter + opt.text" *ngIf="opt.visible && !opt.selected"></option>
                </ng-container>
              </select>
              <div class="dropdown_choices" data-type="dropdown_choices" *ngIf="item.type == 'dropdown_choices'" [ngStyle]="getUnderstandingTextAnswerStyle(item, 'lightgray', true)">
                <i class="icon ion-arrow-down-b"></i>
                <div class="selected-answer" [innerText]="item.content" (click)="dropDownToggle(item.questionId)"></div>
                <div class="options" [ngClass]="{'hidden': !dropDownVisible[item.questionId]}">
                  <ng-container *ngFor="let opt of item.options">
                    <div *ngIf="opt.visible"
                         [attr.data-value]="opt.id" 
                         data-selected="true"[innerHtml]="'<span>' + opt.letter + '</span>' + opt.text" 
                         class="option" [ngClass]="{'selected': opt.selected}" 
                         (click)="onSelectChangeAnswer($event, item.questionId, opt.id)" 
                         [ngStyle]="getUnderstandingTextDropDownAnswerStyle(opt, item.color)">
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
          
          <div 
            class="cs-page-content__canvas-wrapper"
            *ngIf="!(inputs.currentUnderstandingText && inputs.currentUnderstandingText.layout && inputs.currentUnderstandingText.layout !== 'standard')"
          >
            <canvas
              *ngIf="hasImage()"
              [inputs]="{uri: canvasImage}"
              b64ToCanvas>
            </canvas>

			<div
              class="zoom-areas"
              *ngFor="let image of getZoomImages()"
              [ngStyle]="{
                'left': image.x + 'px',
                'top': image.y + 'px'
              }"
			  (click)="openZoomImage(image.zoomImg)">
              <i class="ion-search"></i>
			</div>

            <div
              class="answer-areas"
              [ngClass]="{
                'active': !inputs.isCompleted && interactive_label
              }"
              [ngStyle]="{
                'width': (1 * answer.w + 26) + 'px',
                'height': (1 * answer.h + 2) + 'px',
                'left': answer.x + 'px',
                'top': answer.y + 'px'
              }"
              (click)="interactive_label && answerClick(answer, $event)"
              *ngFor="let answer of inputs.polygons">
              <i
                class="check"
                [ngStyle]="{
                  'color': inputs.currentAnswer?.answerId === answer.id ?
                    inputs.sectionColor : ''
                }"
                [ngClass]="{
                  'ion-android-radio-button-off': inputs.currentAnswer?.answerId !== answer.id,
                  'ion-ios-checkmark': inputs.currentAnswer?.answerId === answer.id,
                  'clickable': !interactive_label
                }"
                *ngIf="answer.visible"
				  (click)="!interactive_label && answerClick(answer, $event)">
              </i>
              <cs-player 
                *ngIf="answer.audioText && answer.visible"
                [inputs]="{
                  currentId: inputs.currentPlayerId,
                  src: answer.audioText.audioURI
                }"
                (play)="audioClick(true, $event)"
                (stop)="audioClick(false)">
              </cs-player>
            </div>
          
          </div>
          <!-- END // .cs-page-content__canvas-wrapper -->
          <div 
            class="watermark-area"
            *ngIf="inputs.watermarkImage"
            [ngStyle]="{top: waterMarkAreaTop + 'px'}"
          >
            <div 
              class="before"
              [style.background-image]="'url(data:image/png;base64,' + 
              inputs.watermarkImage + ')'">
            </div>
          </div>
          <div class="cs-page-content__contenuto-audio-ext-wrapper"
               *ngIf="hasContenutoAudio() && audioContentStyle === 'extended'"
          >
            <cs-ext-audio-player
              [inputs]="{
                  currentId: inputs.currentPlayerId,
                  src: contenutoAudioSrc,
                  sectionColor: inputs.sectionColor,
                  confirmToPlay: inputs.confirmToPlayAudio
                }"
              (play)="audioClick(true, $event)"
              (stop)="audioClick(false)">
            </cs-ext-audio-player>
          </div>
        </div>
    </div>
  `
})

export class CsPageContentComponent implements OnChanges {
  skipScroll: boolean = false;
  lastQuestionId;
  canvasImage;
	interactive_label: boolean = INTERACTIVE_LABEL;
  isMobile: boolean = false;
  scrollAlertClosed: boolean = false;
  safeVideoSrc: SafeResourceUrl = null;
  contenutoAudioSrc: string = null;
  audioContentTitle: string = null;
  videoContentTitle: string = null;

  hasAudioContent: number = 0;
  audioContentStyle: string = 'standard';
  hasVideoContent: number = 0;
  audioMarginLeft: number = 60;
  audioMarginTop: number = 30;
  audioHeight: number = 35;
  videoMaximized: boolean = false;
  videoProvider: any = null;
  videoMarginLeft: number = 60;
  videoMarginTop: number = 30;
  videoWidth: number = 560;
  videoHeight: number = 341;
  videoCurrentWidth: string = '';
  videoCurrentHeight: string = '';
  mouseInVideoWrapper: boolean = false;
  waterMarkAreaTop: number = 0;
  zoomLevel: number = 1;
  bottomBarHeight: number = 72;
  topBarHeight: number = 128;

  understandingTextComponents = [];

  dropDownVisible = {};

  @Input() inputs: any = {};
  @Input() ricettaId: string = '';
  @Output() setAnswer = new EventEmitter<Object>();
  @Output() play = new EventEmitter<Object>();
  @Output() stop = new EventEmitter<Object>();

  @ViewChild('container') container: ElementRef;
  @ViewChild('videoComponentWrapper') videoComponentWrapper: ElementRef;
  @ViewChild('videoComponent') videoComponent: ElementRef;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    let targetRef = new ElementRef(event.target);
    if (targetRef.nativeElement.closest('.dropdown_choices') === null) {
      this.collapseAllDropdownMenu();
    }
  }
  constructor(
    private store: Store<any>,
    private viewActions: ViewActions,
    private assessmentService: AssessmentService,
    private updates$: Actions,
    private chRef: ChangeDetectorRef,
    private utils: Utils,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2
  ) {
    this.updates$
      .ofType(AssessmentActions.NEW_IMAGE_RECEIVED)
      .subscribe((message: any) => {
        if (this.lastQuestionId == message.payload.questionId || this.lastQuestionId == message.payload.hash) {
          this.canvasImage = message.payload.image;
          this.chRef.detach();
          Observable.timer(0, 10).take(1).subscribe((tick) => {
            this.chRef.detectChanges();
            this.chRef.reattach();
          });
        }
      });

    this.isMobile = this.utils.isMobile();
  }

  closeScrollAlert(){
    this.scrollAlertClosed = true;
  }

  playerClick(event) {
    event.preventDefault();
    return false;
  }

  hasImage() {
    return this.inputs &&
      typeof this.canvasImage !== 'undefined';
  }

  hasContenutoVideo() {
    return this.inputs &&
      this.inputs.currentQuestion &&
      this.inputs.currentQuestion.contenutoVideo &&
      typeof this.inputs.currentQuestion.contenutoVideo === 'object';
  }

  hasContenutoAudio() {
    return this.inputs &&
      this.inputs.currentQuestion &&
      this.inputs.currentQuestion.contenutoAudio &&
      typeof this.inputs.currentQuestion.contenutoAudio === 'object';
  }

	openZoomImage(hash) {
    const ricettaImages = this.assessmentService.getImagesByRicettaId(this.ricettaId) || {};
		const zoomImage = ricettaImages[hash];
		if(zoomImage){
			const image_url = `data:image/png;base64,${zoomImage}`;
			this.store.dispatch(this.viewActions.openModalImage({
				image: image_url
			}));
		}
	}

	getZoomImages() {
		let zoom_images = [];
		if(
			this.inputs &&
			this.inputs.currentQuestion &&
			this.inputs.currentQuestion.meta
		){
			const current_meta = this.inputs.currentQuestion.meta || {};
			for(let key in current_meta){
				if(
					key.indexOf('textImage') !== -1 &&
					helpers.isObject(current_meta[key])
				){
					let zoom_image = current_meta[key].zoomImg;
					if(zoom_image && typeof zoom_image === 'string'){
						zoom_images.push(current_meta[key]);
					}

				}
			}
		}
		return zoom_images;
	}

  audioClick(play, event) {
    this.skipScroll = true;
    if (play) {
      this.play.emit(event);
    } else {
      this.stop.emit();
    }
  }

  getUnderstandingTextDropDownAnswerStyle(option, itemColor) {
    let style = {};

    if (option.selected) {
      style['background-color'] = itemColor;
    }

    return style;
  }

  getUnderstandingTextAnswerStyle(item, color?, boldAll?) {
    let style = {
    };
    color = typeof color === 'undefined' ? 'transparent' : color;
    boldAll = typeof boldAll === 'undefined' ? false : boldAll;

    if (item.currentViewing && !boldAll) {
      style['font-weight'] = 'bold';
    }

    if (item.answered) {
      style['border-bottom-color'] = item.color;
    }
    else {
      style['border-bottom-color'] = color;
    }

    if (boldAll) {
      style['font-weight'] = 'bold';
    }

    return style;
  }

  onSelectChangeAnswer (event, questionId, answerId?) {
    answerId = parseInt(typeof answerId === 'undefined' ? event.target.value : answerId);
    answerId = answerId === -1 ? -1 : '' + answerId;
    if (this.inputs.currentQuestion && this.inputs.currentSection) {
      this.setAnswer.emit({
        ricetta: this.inputs.currentSection,
        question: {id: questionId},
        answer: {id: answerId}
      });

      this.skipScroll = true;
    }
    this.dropDownVisible[questionId] = false;
  }

  collapseAllDropdownMenu() {
    for (let i in this.dropDownVisible) {
      if (this.dropDownVisible.hasOwnProperty(i)) {
        this.dropDownVisible[i] = false;
      }
    }
  }

  dropDownToggle(questionId) {
    let nextValue = typeof this.dropDownVisible[questionId] === 'undefined' ? true : !this.dropDownVisible[questionId];
    this.collapseAllDropdownMenu();
    this.dropDownVisible[questionId] = nextValue;
  }

  answerClick(answer, event) {
    let resultAnswer;

    if (this.inputs.isCompleted) {
      return;
    }

    if (event && event.target &&
      event.target.className.indexOf('toggle-play') !== -1) {
      return;
    }

    if (this.inputs.currentQuestion &&
      this.inputs.currentSection) {
      if (this.inputs.currentAnswer &&
        this.inputs.currentAnswer.answerId === answer.id) {
        resultAnswer = {
          id: -1
        };
      } else {
        resultAnswer = answer;
      }

      this.setAnswer.emit({
        ricetta: this.inputs.currentSection,
        question: this.inputs.currentQuestion,
        answer: resultAnswer
      });

      this.skipScroll = true;
    }
  }

  toggleMaximizedVideo(evt) {
    this.videoMaximized = !this.videoMaximized;
    this.videoMaximized ? this.maximizeVideo() : this.restoreVideo();
  }

  maximizeVideo() {
    this.videoCurrentWidth = '100%';
    this.videoCurrentHeight = '100%';
    if (typeof this.container === 'undefined' || typeof this.videoComponent === 'undefined') {
      return;
    }
    this.renderer.appendChild(this.container.nativeElement, this.videoComponent.nativeElement);
  }

  restoreVideo() {
    this.videoCurrentWidth = this.videoWidth + 'px';
    this.videoCurrentHeight = this.videoHeight + 'px';
    if (typeof this.videoComponentWrapper === 'undefined' || typeof this.videoComponent === 'undefined') {
      return;
    }
    this.renderer.appendChild(this.videoComponentWrapper.nativeElement, this.videoComponent.nativeElement);
  }

  mouseEnterInVideoWrapper(evt) {
    this.mouseInVideoWrapper = true;
  }

  mouseLeaveInVideoWrapper(evt) {
    this.mouseInVideoWrapper = false;
  }

  ngOnInit() {
    this.canvasImage = this.inputs.image;
  }

  // ngOnInit() {
  //   if (this.inputs &&
  //     this.inputs.watermarkImage) {
  //     try {
  //       this.watermark.nativeElement
  //         .style
  //         .setProperty(
  //           '--watermark-b64',
  //           'url(data:image/png;base64,' + this.inputs.watermarkImage + ')'
  //         );
  //     } catch (err) { }
  //   }
  // }

  ngOnChanges() {
    let videoSrc = '',
      videoSrcParams
    ;
    if (this.skipScroll) {
      this.skipScroll = false;
      return;
    }

    if (this.inputs.currentQuestion.id === this.lastQuestionId) {
      return;
    }

    this.canvasImage = this.inputs.image;
    this.lastQuestionId = this.inputs.currentQuestion.id;

    this.restoreVideo();
    this.hasVideoContent = 0;
    this.hasAudioContent = 0;
    this.audioContentStyle = 'standard';
    this.safeVideoSrc = null;
    this.contenutoAudioSrc = null;
    this.waterMarkAreaTop = 0;
    this.videoMaximized = false;

    if (this.hasContenutoAudio()) {
      this.contenutoAudioSrc = this.inputs.currentQuestion.contenutoAudio.src;
      this.audioContentTitle = this.inputs.currentQuestion.contenutoAudio.text;
      this.hasAudioContent = 1;
      if (typeof this.inputs.currentQuestion.contenutoAudio.style !== 'undefined' && this.inputs.currentQuestion.contenutoAudio.style) {
        this.audioContentStyle = this.inputs.currentQuestion.contenutoAudio.style;
      }
    }

    if (this.hasContenutoVideo()) {
      this.hasVideoContent = 1;
      this.videoProvider = this.inputs.currentQuestion.contenutoVideo.provider;
      this.videoContentTitle = this.inputs.currentQuestion.contenutoVideo.text;
      switch (this.videoProvider) {
        case 'youtube':
          videoSrcParams = [];
          videoSrcParams.push('allowfullscreen=0');
          videoSrcParams.push('controls=0');
          videoSrcParams.push('fs=0');
          videoSrcParams.push('rel=0');
          videoSrcParams.push('showinfo=0');
          videoSrcParams.push('loop=1');
          videoSrcParams = videoSrcParams.join('&');
          videoSrc = this.inputs.currentQuestion.contenutoVideo.src + '?' + videoSrcParams;
          break;
        case 'vimeo':
          videoSrcParams = [];
          videoSrcParams.push('allowfullscreen=0');
          videoSrcParams.push('title=0');
          videoSrcParams.push('fun=0');
          videoSrcParams.push('loop=1');
          videoSrcParams = videoSrcParams.join('&');
          videoSrc = this.inputs.currentQuestion.contenutoVideo.src + '?' + videoSrcParams;
          break;
      }
      this.safeVideoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(videoSrc);
      //this.waterMarkAreaTop += this.videoHeight + this.videoMarginTop + this.audioMarginTop * this.hasAudioContent;
    }

    try {
      this.container.nativeElement.scrollTop = 0;
    } catch (err) { }

	this.getZoomImages();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-page-content/cs-page-content.component.ts